var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_tab3"
  }, [_c('div', {
    staticClass: "box_contain"
  }, [_c('h1', [_vm._v($t("dnhnle4", "权限管理"))]), _c('p', [_vm._v(` ${$t("8e4gry1j", "应用完全启用还需要钉钉开启接口权限对应用维度做授权，鼓励应用使用尽可能多的接口，实现跟钉钉核心能力的全面互通。")} `)])]), _c('div', {
    staticClass: "line"
  }), _c('div', {
    staticClass: "progress"
  }, [_c('h1', [_vm._v($t("d1up8u4", "操作步骤"))]), _c('p', [_vm._v(` ${$t("8lgc04", "1、选择")} `), _c('a', {
    attrs: {
      "href": "https://open-dev.dingtalk.com/fe/app#/appMgr/inner/h5/1333148458/4",
      "target": "_blank"
    }
  }, [_vm._v($t("dnhnle4", "权限管理"))])]), _c('p', [_vm._v($t("3qdds9w", "2、权限范围：根据实际情况，选择对应范围。建议选择‘全部员工’。"))]), _c('p', [_vm._v($t("pbcmeej", "3、选择，‘通讯录管理’，开启全部权限"))]), _c('p', {
    staticClass: "ti2"
  }, [_c('img', {
    attrs: {
      "src": "https://app-1251575231.cos.ap-shanghai.myqcloud.com/portal/apps/config/Foxmail20211019050934.png",
      "width": "90%"
    }
  })])])]);
}];
export { render, staticRenderFns };